export default {"src":"/_next/static/media/arrows-pointing-out.0fdd3590.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};